module.exports = __webpack_public_path__ + "static/media/300-hours.d16fb8e3.png";